'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconWarning = function IconWarning(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ width: '24px', height: '24px', viewBox: '0 0 24 24' }, custom),
    _react2.default.createElement(
      'g',
      { transform: 'translate(2.000000, 3.000000)', fill: color },
      _react2.default.createElement('path', { d: 'M9.8775,14.07 C9.675,14.07 9.4875,14.0025 9.33,13.86675 C9.18,13.7325 9.0975,13.5435 9.0975,13.3005 C9.0975,13.089 9.1725,12.909 9.3225,12.75975 C9.4725,12.61125 9.6525,12.537 9.87,12.537 C10.0875,12.537 10.2675,12.61125 10.4175,12.75975 C10.575,12.909 10.65,13.089 10.65,13.3005 C10.65,13.5405 10.575,13.728 10.4175,13.8645 C10.2675,14.00175 10.0875,14.07 9.8775,14.07 Z M9.315,10.6965 L9.15,8.24025 C9.12,7.7625 9.0975,7.419 9.0975,7.20975 C9.0975,6.92625 9.1725,6.705 9.3225,6.546 C9.4725,6.38775 9.6675,6.3075 9.9075,6.3075 C10.2075,6.3075 10.4025,6.4095 10.5,6.61275 C10.5975,6.816 10.65,7.10925 10.65,7.49175 C10.65,7.7175 10.635,7.947 10.6125,8.17875 L10.395,10.70625 C10.3725,11.00775 10.32,11.238 10.2375,11.3985 C10.1625,11.559 10.0275,11.64 9.8475,11.64 C9.6675,11.64 9.54,11.562 9.465,11.406 C9.39,11.25075 9.345,11.0145 9.315,10.6965 L9.315,10.6965 Z', id: 'Fill-1051' }),
      ' ',
      _react2.default.createElement('path', { d: 'M2.055,16.0605 L17.88,16.0605 L9.9675,2.35425 L2.055,16.0605 Z M19.185,17.5605 L0.7575,17.5605 C0.4875,17.5605 0.24,17.41725 0.105,17.1855 C-0.03,16.953 -0.03,16.66725 0.105,16.4355 L9.3225,0.47925 C9.585,0.015 10.35,0.015 10.62,0.47925 L19.83,16.4355 C19.965,16.66725 19.965,16.953 19.83,17.1855 C19.695,17.41725 19.4475,17.5605 19.185,17.5605 L19.185,17.5605 Z', id: 'Fill-1052' }),
      ' '
    )
  );
};

IconWarning.propTypes = {
  color: _propTypes2.default.string
};

IconWarning.defaultProps = {
  color: _colors2.default.icons
};

IconWarning.displayName = 'IconWarning';

exports.default = IconWarning;
module.exports = exports.default;